import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MasterCategoryTab } from './MasterCategoryTab';
import {
  pSubCategoriesOf, pCategoriesOf, addPSubCategory, updatePSubCategory, deletePSubCategory,
  gstRatesOf,
} from '../../data/store';
import { useSharedStore } from '../../hooks/useSharedStore';
export const PSubCategoryTab = ({ org, showNotification }) => {
  const { version: dataVersion } = useSharedStore();
  const parents = useMemo(() => pCategoriesOf(org.id), [org.id, dataVersion]);
  // Retired rates are kept off the list - that is what retiring one is for.
  const rates = useMemo(() => gstRatesOf(org.id).filter((g) => g.status !== 'Inactive'),
    [org.id, dataVersion]);
  return (
    <MasterCategoryTab
      org={org}
      title="P-Sub-Categories"
      singular="P-Sub-Category"
      list={() => pSubCategoriesOf(org.id)}
      needsParent
      parents={parents}
      parentLabel="Parent P-Category"
      gstRates={rates}
      onCreate={addPSubCategory}
      onUpdate={updatePSubCategory}
      onDelete={deletePSubCategory}
      showNotification={showNotification}
    />
  );
};

PSubCategoryTab.propTypes = {
  org: PropTypes.object.isRequired,
  showNotification: PropTypes.func,
};
